import styled from 'styled-components';

export const RecordTimelineDiv = styled.div`
  width: 100%;
  display: flex;
  padding: 10px 0;
  flex-direction: column;
  align-items: center;
  position: relative;
`;
